import { render, staticRenderFns } from "./EnergySupportCatering.vue?vue&type=template&id=2ed380db&scoped=true"
import script from "./EnergySupportCatering.vue?vue&type=script&lang=js"
export * from "./EnergySupportCatering.vue?vue&type=script&lang=js"
import style0 from "./EnergySupportCatering.vue?vue&type=style&index=0&id=2ed380db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed380db",
  null
  
)

export default component.exports